import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseService } from "./base.service";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";

import { IDashboard } from "../interfaces/idashboard";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
export class DashboardService extends BaseService {
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    getDashboardContent(countryCode: string): Observable<IDashboard> {
        return super.get(`/api/dashboard/${countryCode}`).pipe(map((res: any) => res as IDashboard));
    }
}




